/* eslint-disable */

import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    user : {
      sessionId: null,
      personelId: 0,
      personelName: null,
      retailerId: 0,
      retailerName: null,
      isAuthenticated: false,
      /* --- */
      canViewStok: false,
      canAddStok: false,
      canSpendStok: false,
      canDeleteStok: false,
      /* --- */
      canAddAriza: false,
      canViewAriza: false,
      canUpdateAriza: false,
      canAssignTrackingNumber: false,
      canDeleteAriza: false,
      /* --- */
      canWriteMessage: false,
      canReadMessage: false,
      /* --- */
      canCreateProduct: false,
      canViewProducts: false,
      canDeleteProduct: false,
      canCalculateProduction: false,
      /* --- */
      canViewUrunCikis: false,
      canInsertUrunCikis: false,
      canUpdateUrunCikis: false,
      canDeleteUrunCikis: false,
      /* --- */
      canViewSahaOperasyon: false,
      canInsertSahaOperasyon: false,
      canUpdateSahaOperasyon: false,
      canDeleteSahaOperasyon: false,
      /* --- */
      canAddDeviceToCustomer: false,
      canExportDeviceToRetailer: false,
      /* --- */
      canViewSerials: false,
      canAddSerials: false,
      /* --- */
      canUseNotes: false,
      canSetPrices: false,
      canViewSIMCards: false,
      /* --- */
      canViewUetds: false,
    },
    application : {
      navigationPin: false,
      pageTitle: '',
    },
    isAppLoading: true,
    isFirstLoading: true,
    code_verifier: null,
  },
  mutations: {
    setAuthStatus(state, authStatus) {
      state.user.isAuthenticated = authStatus
    },
    setSession(state, sessionObject) {
      state.user.isAuthenticated = true
      state.user.sessionId = sessionObject.SessionId
      state.user.personelId = sessionObject.PersonelId
      state.user.personelName = sessionObject.PersonelName
      state.user.retailerId = sessionObject.RetailerId
      state.user.retailerName = sessionObject.RetailerName
      /* --- */
      state.user.canViewStok = sessionObject.CanViewStok
      state.user.canAddStok = sessionObject.CanAddStok
      state.user.canSpendStok = sessionObject.CanSpendStok
      state.user.canDeleteStok = sessionObject.CanDeleteStok
      /* --- */
      state.user.canAddAriza = sessionObject.CanAddAriza
      state.user.canViewAriza = sessionObject.CanViewAriza
      state.user.canUpdateAriza = sessionObject.CanUpdateAriza
      state.user.canDeleteAriza = sessionObject.CanDeleteAriza
      state.user.canAssignTrackingNumber = sessionObject.CanAssignTrackingNumber
      /* --- */
      state.user.canWriteMessage = sessionObject.CanWriteMessage
      state.user.canReadMessage = sessionObject.CanReadMessage
      /* --- */
      state.user.canCreateProduct = sessionObject.CanCreateProduct
      state.user.canViewProducts = sessionObject.CanViewProducts
      state.user.canDeleteProduct = sessionObject.CanDeleteProduct
      state.user.canCalculateProduction = sessionObject.CanCalculateProduction
      /* --- */
      state.user.canViewUrunCikis = sessionObject.CanViewUrunCikis
      state.user.canInsertUrunCikis = sessionObject.CanInsertUrunCikis
      state.user.canUpdateUrunCikis = sessionObject.CanUpdateUrunCikis
      state.user.canDeleteUrunCikis = sessionObject.CanDeleteUrunCikis
      /* -- */
      state.user.canViewSahaOperasyon = sessionObject.CanViewSahaOperasyon
      state.user.canInsertSahaOperasyon = sessionObject.CanInsertSahaOperasyon
      state.user.canUpdateSahaOperasyon = sessionObject.CanUpdateSahaOperasyon
      state.user.canDeleteSahaOperasyon = sessionObject.CanDeleteSahaOperasyon
      /* --- */
      state.user.canAddDeviceToCustomer = sessionObject.CanAddDeviceToCustomer
      state.user.canExportDeviceToRetailer = sessionObject.CanExportDeviceToRetailer
      /* --- */
      state.user.canViewSerials = sessionObject.CanViewSerials
      state.user.canAddSerials = sessionObject.CanAddSerials
      /* --- */
      state.user.canUseNotes = sessionObject.CanUseNotes
      state.user.canSetPrices = sessionObject.CanSetPrices
      state.user.canViewSIMCards = sessionObject.CanViewSIMCards
      state.user.canViewUetds = sessionObject.CanViewUetds
    },
    clearSession(state) {
      state.user.sessionId = null
      state.user.personelId = 0
      state.user.personelName = null
      state.user.retailerId = 0
      state.user.retailerName = null
      /* --- */
      state.user.canViewStok = false
      state.user.canAddStok = false
      state.user.canSpendStok = false
      state.user.canDeleteStok = false
      /* --- */
      state.user.canAddAriza = false
      state.user.canViewAriza = false
      state.user.canUpdateAriza = false
      state.user.canDeleteAriza = false
      state.user.canAssignTrackingNumber = false
      /* --- */
      state.user.canWriteMessage = false
      state.user.canReadMessage = false
      /* --- */
      state.user.canCreateProduct = false
      state.user.canViewProducts = false
      state.user.canDeleteProduct = false
      state.user.canCalculateProduction = false
      /* --- */
      state.user.canViewUrunCikis = false
      state.user.canInsertUrunCikis = false
      state.user.canUpdateUrunCikis = false
      state.user.canDeleteUrunCikis = false
      /* --- */
      state.user.canViewSahaOperasyon = false
      state.user.canInsertSahaOperasyon = false
      state.user.canUpdateSahaOperasyon = false
      state.user.canDeleteSahaOperasyon = false
      /* --- */
      state.user.canAddDeviceToCustomer = false
      state.user.canExportDeviceToRetailer = false
      /* --- */
      state.user.canViewSerials = false
      state.user.canAddSerials = false
      /* --- */
      state.user.canUseNotes = false
      state.user.canSetPrices = false
      /* --- */
      state.user.canViewUetds = false
      /* --- */      
      state.user.isAuthenticated = false
      state.code_verifier = null
      /* --- */
      localStorage.removeItem('utks-sessionid')
      localStorage.removeItem('utks-realname')
      localStorage.removeItem('utks-all-session')
      localStorage.removeItem('utks-token')
    },
    changeFirstLoading(state, newState) {
      state.isFirstLoading = newState
    },
    changeLoadingState(state, newState) {
      state.isAppLoading = newState
    },
    pinNavigationDrawer(state, pinMode) {
      state.application.navigationPin = pinMode
    },
  },
  actions: {
    login2({commit}, user) {
      return new Promise((resolve, reject) => {
        axios.post('/api/session/login',
        { 'SessionId': '', 'UserName': user.UserName, 'Password': user.Password, "PeerIP": user.PeerIP, 'Agent': 'utks.lenoi.net' })
        .then(response => {
          console.log('login dispatched')
          localStorage.setItem('utks-sessionid', response.data.SessionId);
          localStorage.setItem('utks-realname', response.data.PersonelName);
          localStorage.setItem('utks-all-session', JSON.stringify(response.data));
          
          console.log(response.data.SessionId)
          commit('setSession', response.data)
          console.log('sessionize')
          resolve(response)
        })
        .catch(error => reject(error))
      })
    },
    login({commit}, user) {
      return new Promise((resolve, reject) => {
        axios.post('/api/session/login', 
          {'SessionId': '', 'UserName': user.UserName, 'Password': user.Password, "PeerIP": user.PeerIP, 'Agent': 'utks.lenoi.net' }
        ).then(response => {
          axios.defaults.headers.common = { 'Authorization': 'Bearer ' + response.data.Token }
          console.log(response.data)
          localStorage.setItem('utks-token', response.data.Token)
          resolve(response)
        }).catch(err => reject(err))
      })
    },
    logout({commit}) {
      commit('clearSession')
    },
    checkSession({commit}) {
      return new Promise((resolve, reject) => {
        axios.post('/api/session/checkin', {})
        .then(response => {
          resolve(response)
        })
        .catch(error => reject(error))
      })
    },
    readUserConfig({commit}) {
      return new Promise((resolve, reject) => {
        axios.post('/api/session/user-config')
        .then(response => {
          console.log('readUserConfig dispatched ---')
          localStorage.setItem('utks-sessionid', response.data.SessionId);
          localStorage.setItem('utks-realname', response.data.PersonelName);
          localStorage.setItem('utks-all-session', JSON.stringify(response.data));

          commit('setSession', response.data)
          resolve(response)
        })
        .catch(error => reject(error))
      })
    },
    readSessionFromLocalStorage({commit}) {
      return new Promise((resolve, reject) => {
        let tokenObj = localStorage.getItem('utks-token')
        let sessionObj = localStorage.getItem('utks-all-session')

        let isTokenRead = tokenObj != null && tokenObj.length > 0 && tokenObj !== 'undefined' && tokenObj !== 'null'
        let isSessionRead = sessionObj != null && sessionObj.length > 0 && sessionObj !== 'undefined' && sessionObj !== 'null'
        
        if(isTokenRead)
          axios.defaults.headers.common = { 'Authorization': 'Bearer ' + tokenObj }

        if(isSessionRead)
          commit('setSession', JSON.parse(sessionObj))
        
        resolve({ 'isTokenRead': isTokenRead, 'isSessionRead': isSessionRead })
      })
    },
    changePinMode({commit}, pinMode) {
      commit('pinNavigationDrawer', pinMode)
    },
    setAuthStatus({commit}, authStatus) {
      commit('setAuthStatus', authStatus)
    },
    changeFirstLoading({commit}, loadingState) {
      commit('changeFirstLoading', loadingState)
    },
    changeLoadingState({commit}, loadingState) {
      commit('changeLoadingState', loadingState)
    },
  },
  getters: {
    isFirstLoading: state => state.isFirstLoading,
    isAppLoading: state => state.isAppLoading,
    isAuthenticated: state => state.user.isAuthenticated,
    code_verifier: state => state.code_verifier,
    /* --- */
    getSessionId: state => state.user.sessionId,
    getPersonelName: state => state.user.personelName,
    getPersonelId: state => state.user.personelId,
    /* --- */
    userCanViewAriza: state => state.user.canViewAriza,
    userCanAddAriza: state => state.user.canAddAriza,
    userCanUpdateAriza: state => state.user.canUpdateAriza,
    userCanDeleteAriza: state => state.user.canDeleteAriza,
    /* --- */
    userCanViewStok: state => state.user.canViewStok,
    userCanAddStok: state => state.user.canAddStok,
    userCanSpendStok: state => state.user.canSpendStok,
    userCanAssignTrackingNumber: state => state.user.canAssignTrackingNumber,
    userCanDeleteStok: state => state.user.canDeleteStok,
    /* --- */
    userCanWriteMessage: state => state.user.canWriteMessage,
    userCanReadMessage: state => state.user.canReadMessage,
    /* --- */ 
    userCanCreateProduct: state => state.user.canCreateProduct,
    userCanViewProducts: state => state.user.canViewProducts,
    userCanDeleteProduct: state => state.user.canDeleteProduct,
    userCanCalculateProduction: state => state.user.canCalculateProduction,
    /* --- */      
    userCanInsertUrunCikis: state => state.user.canInsertUrunCikis,
    userCanUpdateUrunCikis: state => state.user.canUpdateUrunCikis,
    userCanViewUrunCikis: state => state.user.canViewUrunCikis,
    userCanDeleteUrunCikis: state => state.user.canDeleteUrunCikis,
    /* --- */      
    userCanInsertSahaOperasyon: state => state.user.canInsertSahaOperasyon,
    userCanUpdateSahaOperasyon: state => state.user.canUpdateSahaOperasyon,
    userCanViewSahaOperasyon: state => state.user.canViewSahaOperasyon,
    userCanDeleteSahaOperasyon: state => state.user.canDeleteSahaOperasyon,
    /* --- */
    userCanAddDeviceToCustomer: state => state.user.canAddDeviceToCustomer,
    userCanExportDeviceToRetailer: state => state.user.canExportDeviceToRetailer,
    /* --- */
    userCanAddSerials: state => state.user.canAddSerials,
    userCanViewSerials: state => state.user.canViewSerials,
    /* --- */
    userCanUseNotes: state => state.user.canUseNotes,
    userCanSetPrices: state => state.user.canSetPrices,
    userCanViewSIMCards: state => state.user.canViewSIMCards,
    /* --- */
    userCanViewUetds: state => state.user.canViewUetds,
    /* --- */
    appNavigationPinned: state => state.application.navigationPin
  },
})

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js